/*
*   When using this method to push log to backend, you must make sure it will not send immensely
*   OR it will write a large size log, maybe cause issues.
*/

import services from '../../services/axios-services';
import servicesConfig, { IServiceConfig } from '../../services/servicesConfig';

const pushLogToBackend = (params: any) => {
    const failMsg = 'Remote log failure for log :';
    const successMsg = 'Remote log complete for log :';
    const serviceDetail: IServiceConfig = servicesConfig.PUSH_LOG_TO_BACKEND;

    services.getData(serviceDetail, params, '')
    .then((response: any) => {
        console.log(successMsg + params.msg);
    })
    .catch((e: any) => {
        console.error(failMsg + params.msg, e);
    });
};

export default pushLogToBackend;
